// @ts-nocheck
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { CountryCode } from "libphonenumber-js";

export function isValidPhone(value, countryCode: CountryCode | null) {
  if (!value) {
    return value;
  }

  const phoneNum = parsePhoneNumberFromString(value, countryCode);
  return !!phoneNum?.isValid();
}
